export default "__VITE_ASSET__DHEAaecp__"